import React, { Component } from 'react';
import Loading from '../../components/Loading';
import axios from '../../utils/axios';
import { GetStorageComponent } from '../../utils/storage';
import AuthInstance from '../../Auth/Auth';

class Logout extends Component <{}> {

  componentDidMount() {
    AuthInstance.checkSSO((err, result) => {
      const accessToken = GetStorageComponent('access_token');
      if ( result ) {
        axios.request({
          method: 'post',
          url: '/userengagement/logout',
          headers: {
            Authorization: 'bearer ' + accessToken
          }
        }).then(() => {
          AuthInstance.logout();
        }).catch(() => {
          AuthInstance.logout();
        });
      } else {
        AuthInstance.logout();
      }
    })
  }

  
  render () {
    return(
      <Loading pastDelay={true} className="loader-wrap big-loader"/>
    );
  }
}

export default Logout;